/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSupplierOrganizationDto
 */
export interface UpdateSupplierOrganizationDto {
    /**
     * Organization name
     * @type {string}
     * @memberof UpdateSupplierOrganizationDto
     */
    organizationName?: string;
    /**
     * Commercial registration number
     * @type {string}
     * @memberof UpdateSupplierOrganizationDto
     */
    commercialNumber?: string;
    /**
     * Tax identification number
     * @type {string}
     * @memberof UpdateSupplierOrganizationDto
     */
    taxNumber?: string;
    /**
     * Business types
     * @type {Array<string>}
     * @memberof UpdateSupplierOrganizationDto
     */
    businessTypes?: Array<UpdateSupplierOrganizationDtoBusinessTypesEnum>;
    /**
     * Contact info ID
     * @type {number}
     * @memberof UpdateSupplierOrganizationDto
     */
    contactInfoId?: number;
    /**
     * Disable/enable organization
     * @type {boolean}
     * @memberof UpdateSupplierOrganizationDto
     */
    disabled?: boolean;
}


/**
 * @export
 */
export const UpdateSupplierOrganizationDtoBusinessTypesEnum = {
    Manufacturer: 'MANUFACTURER',
    Importer: 'IMPORTER',
    Distributor: 'DISTRIBUTOR'
} as const;
export type UpdateSupplierOrganizationDtoBusinessTypesEnum = typeof UpdateSupplierOrganizationDtoBusinessTypesEnum[keyof typeof UpdateSupplierOrganizationDtoBusinessTypesEnum];


/**
 * Check if a given object implements the UpdateSupplierOrganizationDto interface.
 */
export function instanceOfUpdateSupplierOrganizationDto(value: object): value is UpdateSupplierOrganizationDto {
    return true;
}

export function UpdateSupplierOrganizationDtoFromJSON(json: any): UpdateSupplierOrganizationDto {
    return UpdateSupplierOrganizationDtoFromJSONTyped(json, false);
}

export function UpdateSupplierOrganizationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSupplierOrganizationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'commercialNumber': json['commercialNumber'] == null ? undefined : json['commercialNumber'],
        'taxNumber': json['taxNumber'] == null ? undefined : json['taxNumber'],
        'businessTypes': json['businessTypes'] == null ? undefined : json['businessTypes'],
        'contactInfoId': json['contactInfoId'] == null ? undefined : json['contactInfoId'],
        'disabled': json['disabled'] == null ? undefined : json['disabled'],
    };
}

export function UpdateSupplierOrganizationDtoToJSON(value?: UpdateSupplierOrganizationDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'organizationName': value['organizationName'],
        'commercialNumber': value['commercialNumber'],
        'taxNumber': value['taxNumber'],
        'businessTypes': value['businessTypes'],
        'contactInfoId': value['contactInfoId'],
        'disabled': value['disabled'],
    };
}

